import React, { useState } from "react";

// Questionnaire de vérification (mode Entrevue) — 5 questions legacy
// comptabilisées dans tQuestionnaire. Le choix Conditionnelle/Entrevue se
// fait désormais AVANT (ModeDemandeModal) : plus d'étape « conditionnelle ? ».
export default function QuestionnaireModal({ client, requerant, onNonValide, onCancel, ctaLabel }) {
  const [rep, setRep] = useState({
    nouveau_client: false,
    admis_12_mois: false,
    financiere_inchangee: false,
    sante_mentale: false,
    detenu: false,
    vcvs: false,
    premieres_nations: false,
    immigration: false,
    cour_itinerante: false,
    itinerance: false,
    aide_sociale: false,
    tiers_impossibilite: false,
    benefice_autrui: false,
  });
  const [saving, setSaving] = useState(false);

  const noClient = client?.no_client || client?.id || null;
  const derniereDemande = client?.derniere_demande || null;
  // Mention « plus d'un an » si la dernière demande dépasse un an aujourd'hui.
  let derniereInfo = null;
  if (derniereDemande) {
    const d = new Date(derniereDemande);
    if (!isNaN(d.getTime())) {
      const now = new Date();
      const unAn = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
      derniereInfo = { date: derniereDemande, plusDUnAn: d < unAn };
    }
  }

  // Identité pour le titre : NOM en majuscules, Prénom capitalisé, DDN + âge.
  const idNom = (requerant?.nom || client?.nom || "").trim().toUpperCase();
  const idPrenom = (() => {
    const p = (requerant?.prenom || client?.prenom || "").trim();
    return p ? p.charAt(0).toUpperCase() + p.slice(1).toLowerCase() : "";
  })();
  const idDDN = requerant?.date_naissance || client?.date_naissance || null;
  const idAge = (() => {
    if (!idDDN) return null;
    const d = new Date(idDDN);
    if (isNaN(d.getTime())) return null;
    const now = new Date();
    let a = now.getFullYear() - d.getFullYear();
    const m = now.getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < d.getDate())) a -= 1;
    return a;
  })();
  const idTitre = [
    [idNom, idPrenom].filter(Boolean).join(", "),
    idDDN ? `${idDDN}${idAge != null ? ` (${idAge} ans)` : ""}` : "",
  ].filter(Boolean).join(" · ");

  const set = (k, v) => setRep(prev => {
    const next = { ...prev, [k]: v };
    // Règles legacy : Nouveau client → pas admis 12 mois ; FinInchangée liée à Admis12
    if (k === "nouveau_client" && v) { next.admis_12_mois = false; next.financiere_inchangee = false; }
    if (k === "admis_12_mois" && !v) next.financiere_inchangee = false;
    return next;
  });

  const valider = async () => {
    setSaving(true);
    try { await onNonValide(rep); } finally { setSaving(false); }
  };

  const lignes = [
    ["nouveau_client", "Il s'agit de sa première demande à l'aide juridique.", false],
    ["admis_12_mois", "Le requérant a été admis à l'aide juridique au cours des 12 derniers mois.", rep.nouveau_client],
    ["financiere_inchangee", "Sa situation financière ou familiale demeure la même.", !rep.admis_12_mois],
    ["sante_mentale", "Le requérant souffre de troubles de santé mentale.", false],
    ["detenu", "Le requérant est détenu.", false],
    ["vcvs", "Le requérant est dans un contexte de VCVS.", false],
    ["premieres_nations", "Le requérant est membre des premières nations.", false],
    ["immigration", "Le requérant fait une demande en droit de l'immigration.", false],
    ["cour_itinerante", "Le requérant a un dossier à la Cour itinérante (614, 625, 635, 640, 652).", false],
    ["itinerance", "Le requérant est en situation d'itinérance.", false],
    ["aide_sociale", "Le requérant reçoit des prestations d'aide sociale ou de solidarité sociale (exclut PRB et objectif emploi).", false],
    ["tiers_impossibilite", "Le requérant fait une demande au nom d'un tiers qui est dans l'impossibilité d'agir (art. 30 al.1).", false],
    ["benefice_autrui", "Le requérant fait une demande pour un service pour le bénéfice d'autrui (art. 30 al.2).", false],
  ];

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300 }}>
      <div style={{ background: "#f0f0f0", border: "1px solid #808080",
                    boxShadow: "3px 3px 8px rgba(0,0,0,0.3)", width: 940, maxWidth: "96vw" }}
           data-testid="questionnaire-modal">
        <div style={{ background: "linear-gradient(180deg,#1e5aa8,#164a8f)", color: "#fff",
                      padding: "8px 12px", fontWeight: 700, fontSize: 15,
                      display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          <span>PRÉ-ADMISSION</span>
          {idTitre && <span data-testid="questionnaire-titre-client" style={{ fontSize: 14, fontWeight: 600, opacity: 0.95 }}>{idTitre}</span>}
        </div>
        <div style={{ padding: 20, fontSize: 15 }}>
          <p style={{ marginTop: 0, marginBottom: 30, color: "#333", fontSize: 15, fontWeight: 700 }}>
            Cochez les situations applicables au requérant :
          </p>
          {lignes.map(([k, label, disabled]) => (
            <div key={k} style={{ marginBottom: 12 }}>
              <label style={{ display: "flex", alignItems: "flex-start", gap: 10,
                              whiteSpace: "normal", fontSize: 15, lineHeight: 1.4,
                              opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}>
                <input type="checkbox" checked={rep[k]} disabled={disabled}
                       onChange={e => set(k, e.target.checked)}
                       data-testid={`questionnaire-${k.replace(/_/g, "-")}`}
                       style={{ width: 16, height: 16, flexShrink: 0, marginTop: 3 }} />
                <span>{label}</span>
              </label>
              {k === "nouveau_client" && noClient && (
                <div data-testid="questionnaire-info-client"
                     style={{ marginLeft: 26, marginTop: 2, fontSize: 13, fontWeight: 700, color: "#0a6b0a" }}>
                  ↳ Client retrouvé — No client {noClient}
                </div>
              )}
              {k === "admis_12_mois" && derniereInfo && (
                <div data-testid="questionnaire-info-derniere"
                     style={{ marginLeft: 26, marginTop: 2, fontSize: 13, fontWeight: 700,
                              color: derniereInfo.plusDUnAn ? "#a15c00" : "#0a6b0a" }}>
                  ↳ Dernière demande : {derniereInfo.date}
                  {derniereInfo.plusDUnAn ? " (plus d'un an)" : " (moins d'un an)"}
                </div>
              )}
            </div>
          ))}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
            <button className="win-btn" onClick={onCancel}
                    data-testid="questionnaire-annuler">Annuler</button>
            <button className="win-btn" onClick={valider} disabled={saving}
                    style={{ background: "#1e5aa8", color: "#fff", fontWeight: 700 }}
                    data-testid="questionnaire-valider">
              {saving ? "…" : (ctaLabel || "Créer l'entrevue")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
